module.exports = __webpack_public_path__ + "static/media/logo-plus.85ffb614.svg";